<template>
  <main @click.stop="openActiveZone">

    <div v-if="!loading" class="containerLoader">
      <div  class="centrarLoader">
        <v-progress-circular
          :size="150"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </div>
    
    <ul id="viewer" class="double" :style="'overflow-y: hidden;opacity:' + ($store.state.loading?1:0)">
      <li id="pageLM">
        <canvas class="blank" data-drawed="true" id='canvasMain' width="500" height="300">
        </canvas>
        <article class="page" :style="'width:' + ($store.state.twoPages && $store.state.index != 0 && $store.state.index != $store.state.ebook[$store.state.indexLM].paginas.length - 1 ?'50%':'100%;text-align:center')">
          <div @mousedown="selectOne = true; selectTwo = false;" id="pageOne" class="html-page" :style="'height:' + sizeScreen + '%'">  
            <!--AQUI SE MUESTRA LAS ZONA ACTIVAS, ENLACES Y CUADRO DE TEXTO DE LA PAGINA IZQUIERDA-->
            <aside :data-page="$store.state.index" id='contenedorZona_1' class="interactive" style="left: 0px; top: 0px;">
              <div class="zonaTransparente" hidden></div>
              <template v-for="zone in zonasActivas[$store.state.indexLM]['pag_' + $store.state.index]">
                
                <div :key="zone.id" class="activeZone" 
                  :style="{
                            'transform':
                            'scale(' + scale3d + ') translate(' + zone.x + 'px, ' + zone.y + 'px)',
                          }">
                          
                  <!--Si la zona activa es pdf-->
                  <template v-if="zone.tipo == 'pdf' || zone.tipo == 'docx' || zone.tipo == 'doc' || zone.tipo == 'xlsx' || zone.tipo == 'xls' || zone.tipo == 'pptx' || zone.tipo == 'ppt' || zone.tipo == 'pps' || zone.tipo == 'ppsx'">
                    <!--Es transparente?-->
                    <template v-if="zone.transparente">
                      <!--Modo Edicion para transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="editZone(zone)" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                      <!--Modo Normal transparente-->
                      <template v-else>
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="openDocumento(zone.tipo ,zone.recurso)" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                    </template>
                    <!--Boton definido-->
                    <template v-else>
                      <a @mouseover="zoneHover(zone.id)" class="btnZone pdfZone" target="_blank" @click="openDocumento(zone.tipo ,zone.recurso)" :title="zone.titulo"></a>
                      <!--Modo Edicion para no transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div @mouseout="zoneOut(zone.id)" @click="editZone(zone)" class="editZone" :ref="'zone-' + zone.id">
                          <i class="fa fa-edit"></i>
                        </div>
                      </template>
                    </template>
                    
                  </template>
                  
                  <!--Si la zona activa es un html-->
                  <template v-if="zone.tipo == 'html'">
                    <!--Es transparente?-->
                    <template v-if="zone.transparente">
                      <!--Modo Edicion para transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="editZone(zone)" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                      <!--Modo Normal transparente-->
                      <template v-else>
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="setModalResourceFull({isOpen: true, resource: zone.recurso})" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                    </template>
                    <!--Boton definido-->
                    <template v-else>
                      <a class="btnZone htmlZone" @mouseover="zoneHover(zone.id)"  @click="setModalResourceFull({isOpen: true, resource: zone.recurso})" :title="zone.titulo"></a>
                      <!--Modo Edicion para no transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div @mouseout="zoneOut(zone.id)" @click="editZone(zone)" class="editZone" :ref="'zone-' + zone.id">
                          <i class="fa fa-edit"></i>
                        </div>
                      </template>
                    </template>
                  </template>

                    <!--Si la zona activa es un enlace web-->
                  <template v-if="zone.tipo == 'linkWeb'">
                    <!--Es transparente?-->
                    <template v-if="zone.transparente">
                      <!--Modo Edicion para transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="editZone(zone)"
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                      <!--Modo Normal transparente-->
                      <template v-else>
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="openLinkWeb(zone.url)" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                    </template>
                    <!--Boton definido-->
                    <template v-else>
                      <a @mouseover="zoneHover(zone.id)" class="btnZone linkZone" @click="openLinkWeb(zone.url)" target="_blank" :title="zone.titulo"></a>
                      <!--Modo Edicion para no transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div @mouseout="zoneOut(zone.id)" @click="editZone(zone)" class="editZone" :ref="'zone-' + zone.id">
                          <i class="fa fa-edit"></i>
                        </div>
                      </template>
                    </template>
                    
                  </template>

                  <!--Si la zona activa es un enlace a una pagina-->
                  <template v-if="zone.tipo == 'linkPage'">
                     <!--Es transparente?-->
                    <template v-if="zone.transparente">
                      <!--Modo Edicion para transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="editZone(zone)" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                      <!--Modo Normal transparente-->
                      <template v-else>
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click.stop="correcionLM(zone.lm);buscarLMUnidad({lm: zone.lm,unitIndex: zone.page});" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                    </template>
                    <!--Boton definido-->
                    <template v-else>
                      <a @mouseover="zoneHover(zone.id)" class="btnZone linkZone" @click.stop="correcionLM(zone.lm);buscarLMUnidad({lm: zone.lm,unitIndex: zone.page});" :title="zone.titulo"></a>
                      <!--Modo Edicion para no transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div @mouseout="zoneOut(zone.id)" @click="editZone(zone)" class="editZone" :ref="'zone-' + zone.id">
                          <i class="fa fa-edit"></i>
                        </div>
                      </template>
                    </template>
                    
                  </template>

                  <!--Si la zona activa es un audio-->
                  <template v-if="zone.tipo == 'audio'">
                    <!--Es transparente?-->
                    <template v-if="zone.transparente">
                      <!--Modo Edicion para transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="editZone(zone)"
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                      <!--Modo Normal transparente-->
                      <template v-else>
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click.stop="openModalAudioVideo(zone)" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                    </template>
                    <!--Boton definido-->
                    <template v-else>
                      <a @mouseover="zoneHover(zone.id)" class="btnZone audioZone" @click.stop="openModalAudioVideo(zone)" :title="zone.titulo"></a>
                      <!--Modo Edicion para no transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div @mouseout="zoneOut(zone.id)" @click="editZone(zone)" class="editZone" :ref="'zone-' + zone.id">
                          <i class="fa fa-edit"></i>
                        </div>
                      </template>
                    </template>
                    
                  </template>

                  <!--Si la zona activa es un video-->
                  <template v-if="zone.tipo == 'video'">
                    <!--Es transparente?-->
                    <template v-if="zone.transparente">
                      <!--Modo Edicion para transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="editZone(zone)"
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                      <!--Modo Normal transparente-->
                      <template v-else>
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click.stop="openModalAudioVideo(zone)" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                    </template>
                    <!--Boton definido-->
                    <template v-else>
                      <a @mouseover="zoneHover(zone.id)" class="btnZone videoZone" @click.stop="openModalAudioVideo(zone)" :title="zone.titulo"></a>
                      <!--Modo Edicion para no transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div @mouseout="zoneOut(zone.id)" @click="editZone(zone)" class="editZone" :ref="'zone-' + zone.id">
                          <i class="fa fa-edit"></i>
                        </div>
                      </template>
                    </template>
                    
                  </template>

                  <!--Si la zona activa es una nota-->
                  <template v-if="zone.tipo == 'note'">
                    <i class='btnZone noteZone fa fa-comment-alt' @click="openNote"></i>
                    <template v-if="zone.y > 2750 && zone.x > 1800">
                      <div :id="$store.state.index + '-' + zone.id" class='textBox' style="display:none; top:-350px;left:-750px;">
                        <i class="fa fa-times-circle exit" @click="closeNote"></i>
                        <textarea @keyup="addTextNote" v-model="zone.txt" :placeholder="literal['NOTA']"></textarea>
                        <button @click="deleteZoneActive(zone.id)" class="noteDeleteBtn"><i class="fas fa-trash-alt"></i></button>
                      </div>
                    </template>
                    <template v-else-if="zone.y > 2750">
                      <div :id="$store.state.index + '-' + zone.id" class='textBox' style="display:none; top:-350px;">
                        <i class="fa fa-times-circle exit" @click="closeNote"></i>
                        <textarea @keyup="addTextNote" v-model="zone.txt" :placeholder="literal['NOTA']"></textarea>
                        <button @click="deleteZoneActive(zone.id)" class="noteDeleteBtn"><i class="fas fa-trash-alt"></i></button>
                      </div>
                    </template>
                    <template v-else-if="zone.x > 1800">
                      <div :id="$store.state.index + '-' + zone.id" class='textBox' style="display:none; left:-750px;">
                        <i class="fa fa-times-circle exit" @click="closeNote"></i>
                        <textarea @keyup="addTextNote" v-model="zone.txt" :placeholder="literal['NOTA']"></textarea>
                        <button @click="deleteZoneActive(zone.id)" class="noteDeleteBtn"><i class="fas fa-trash-alt"></i></button>
                      </div>
                    </template>
                    <template v-else>
                      <div :id="$store.state.index + '-' + zone.id" class='textBox' style="display:none;">
                        <i class="fa fa-times-circle exit" @click="closeNote"></i>
                        <textarea @keyup="addTextNote" v-model="zone.txt" :placeholder="literal['NOTA']"></textarea>
                        <button @click="deleteZoneActive(zone.id)" class="noteDeleteBtn"><i class="fas fa-trash-alt"></i></button>
                      </div>
                    </template>
                    
                  </template>

                </div>
              </template>
            </aside>
            

            <!--PAGINA IZQUIERDA-->
            <EbookCropper :id="$store.state.index" v-if="isCrop" :literal="literal" :img="rutaImg($store.state.index)"></EbookCropper>
            <img v-else id="pageImgOne" style="width:auto; height:100%" :src="rutaImg($store.state.index)" />
            
            <!--ITERA LAS PESTAÑAS DE LOS LIBROS MEDIAS (SOLO MUESTRA SU ABREVIACION)-->
            <template v-if="$store.state.ebook.length > 1">
              <template v-for="(pestLm, index) in $store.state.ebook">
                <div v-if="index== 0" @click="irLM(index)" :id="'pestanaLM' + index" class="pestana pestanaDesactivada" style="z-index: 20" :key="index">{{pestLm.abrev}}</div> 
                <div v-else @click="irLM(index)" :id="'pestanaLM' + index" :style="'margin-top:'+80*index+'px; z-index: 20'" class="pestana" :key="index">{{pestLm.abrev}}</div> 
              </template>
            </template>
            
          </div>
        </article>
        <article class="page page2" :style="'width:' + ($store.state.twoPages && $store.state.index != 0 && $store.state.index != $store.state.ebook[$store.state.indexLM].paginas.length - 1 ?'50%':'100%;text-align:center')">
          
          <div @mousedown="selectOne = false; selectTwo = true;" id="pageTwo" class="html-page" :style="'height:' + sizeScreen + '%'">
            <!--AQUI SE MUESTRA LAS ZONA ACTIVAS, ENLACES Y CUADRO DE TEXTO DE LA PAGINA DERECHA-->
            <aside :data-page="$store.state.index + 1" id='contenedorZona_2' class="interactive" style="left: -4px; top: 0px;">
              <div class="zonaTransparente" hidden></div>
              <template v-for="zone in zonasActivas[$store.state.indexLM]['pag_' + ($store.state.index + 1)]">
                
                <div :key="zone.id" class="activeZone" 
                  :style="{
                            'transform':
                            'scale(' + scale3d +') translate(' + zone.x + 'px, ' + zone.y + 'px)',
                          }">
                  
                  <!--Si la zona activa es pdf-->
                  <template v-if="zone.tipo == 'pdf' || zone.tipo == 'docx' || zone.tipo == 'doc' || zone.tipo == 'xlsx' || zone.tipo == 'xls' || zone.tipo == 'pptx' || zone.tipo == 'ppt' || zone.tipo == 'pps' || zone.tipo == 'ppsx'">
                    <!--Es transparente?-->
                    <template v-if="zone.transparente">
                      <!--Modo Edicion para transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="editZone(zone)" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                      <!--Modo Normal transparente-->
                      <template v-else>
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="openDocumento(zone.tipo ,zone.recurso)" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                    </template>
                    <!--Boton definido-->
                    <template v-else>
                      <a @mouseover="zoneHover(zone.id)" class="btnZone pdfZone" target="_blank" @click="openDocumento(zone.tipo ,zone.recurso)" :title="zone.titulo"></a>
                      <!--Modo Edicion para no transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div @mouseout="zoneOut(zone.id)" @click="editZone(zone)" class="editZone" :ref="'zone-' + zone.id">
                          <i class="fa fa-edit"></i>
                        </div>
                      </template>
                    </template>
                    
                  </template>
                  
                  <!--Si la zona activa es un html-->
                  <template v-if="zone.tipo == 'html'">
                    <!--Es transparente?-->
                    <template v-if="zone.transparente">
                      <!--Modo Edicion para transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="editZone(zone)" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                      <!--Modo Normal transparente-->
                      <template v-else>
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="setModalResourceFull({isOpen: true, resource: zone.recurso})" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                    </template>
                    <!--Boton definido-->
                    <template v-else>
                      <a class="btnZone htmlZone" @mouseover="zoneHover(zone.id)"  @click="setModalResourceFull({isOpen: true, resource: zone.recurso})" :title="zone.titulo"></a>
                      <!--Modo Edicion para no transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div @mouseout="zoneOut(zone.id)" @click="editZone(zone)" class="editZone" :ref="'zone-' + zone.id">
                          <i class="fa fa-edit"></i>
                        </div>
                      </template>
                    </template>
                  </template>

                    <!--Si la zona activa es un enlace web-->
                  <template v-if="zone.tipo == 'linkWeb'">
                    <!--Es transparente?-->
                    <template v-if="zone.transparente">
                      <!--Modo Edicion para transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="editZone(zone)"
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                      <!--Modo Normal transparente-->
                      <template v-else>
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="openLinkWeb(zone.url)" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                    </template>
                    <!--Boton definido-->
                    <template v-else>
                      <a @mouseover="zoneHover(zone.id)" class="btnZone linkZone" @click="openLinkWeb(zone.url)" target="_blank" :title="zone.titulo"></a>
                      <!--Modo Edicion para no transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div @mouseout="zoneOut(zone.id)" @click="editZone(zone)" class="editZone" :ref="'zone-' + zone.id">
                          <i class="fa fa-edit"></i>
                        </div>
                      </template>
                    </template>
                    
                  </template>

                  <!--Si la zona activa es un enlace a una pagina-->
                  <template v-if="zone.tipo == 'linkPage'">
                     <!--Es transparente?-->
                    <template v-if="zone.transparente">
                      <!--Modo Edicion para transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="editZone(zone)" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                      <!--Modo Normal transparente-->
                      <template v-else>
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click.stop="correcionLM(zone.lm);buscarLMUnidad({lm: zone.lm,unitIndex: zone.page});" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                    </template>
                    <!--Boton definido-->
                    <template v-else>
                      <a @mouseover="zoneHover(zone.id)" class="btnZone linkZone" @click.stop="correcionLM(zone.lm);buscarLMUnidad({lm: zone.lm,unitIndex: zone.page});" :title="zone.titulo"></a>
                      <!--Modo Edicion para no transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div @mouseout="zoneOut(zone.id)" @click="editZone(zone)" class="editZone" :ref="'zone-' + zone.id">
                          <i class="fa fa-edit"></i>
                        </div>
                      </template>
                    </template>
                    
                  </template>

                  <!--Si la zona activa es un audio-->
                  <template v-if="zone.tipo == 'audio'">
                    <!--Es transparente?-->
                    <template v-if="zone.transparente">
                      <!--Modo Edicion para transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="editZone(zone)"
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                      <!--Modo Normal transparente-->
                      <template v-else>
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click.stop="openModalAudioVideo(zone)" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                    </template>
                    <!--Boton definido-->
                    <template v-else>
                      <a @mouseover="zoneHover(zone.id)" class="btnZone audioZone" @click.stop="openModalAudioVideo(zone)" :title="zone.titulo"></a>
                      <!--Modo Edicion para no transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div @mouseout="zoneOut(zone.id)" @click="editZone(zone)" class="editZone" :ref="'zone-' + zone.id">
                          <i class="fa fa-edit"></i>
                        </div>
                      </template>
                    </template>
                    
                  </template>

                  <!--Si la zona activa es un video-->
                  <template v-if="zone.tipo == 'video'">
                    <!--Es transparente?-->
                    <template v-if="zone.transparente">
                      <!--Modo Edicion para transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click="editZone(zone)"
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                      <!--Modo Normal transparente-->
                      <template v-else>
                        <div :title="zone.titulo" class="zonaTransparenteAux" @click.stop="openModalAudioVideo(zone)" 
                          :style="{width: zone.width, height: zone.height, opacity: $store.state.ocultarBarra?1:0}"> 
                        </div>
                      </template>
                    </template>
                    <!--Boton definido-->
                    <template v-else>
                      <a @mouseover="zoneHover(zone.id)" class="btnZone videoZone" @click.stop="openModalAudioVideo(zone)" :title="zone.titulo"></a>
                      <!--Modo Edicion para no transparente-->
                      <template v-if="!$store.state.isModeActiveZone && openHZone && zone.id">
                        <div @mouseout="zoneOut(zone.id)" @click="editZone(zone)" class="editZone" :ref="'zone-' + zone.id">
                          <i class="fa fa-edit"></i>
                        </div>
                      </template>
                    </template>
                    
                  </template>

                  <!--Si la zona activa es una nota-->
                  <template v-if="zone.tipo == 'note'">
                    <i class='btnZone noteZone fa fa-comment-alt' @click="openNote"></i>
                    <template v-if="zone.y > 2750 && zone.x > 1800">
                      <div :id="$store.state.index + 1 + '-' + zone.id" class='textBox' style="display:none; top:-350px;left:-750px;">
                        <i class="fa fa-times-circle exit" @click="closeNote"></i>
                        <textarea @keyup="addTextNote" v-model="zone.txt" :placeholder="literal['NOTA']"></textarea>
                        <button @click="deleteZoneActive(zone.id)" class="noteDeleteBtn"><i class="fas fa-trash-alt"></i></button>
                      </div>
                    </template>
                    <template v-else-if="zone.y > 2750">
                      <div :id="$store.state.index + 1 + '-' + zone.id" class='textBox' style="display:none; top:-350px;">
                        <i class="fa fa-times-circle exit" @click="closeNote"></i>
                        <textarea @keyup="addTextNote" v-model="zone.txt" :placeholder="literal['NOTA']"></textarea>
                        <button @click="deleteZoneActive(zone.id)" class="noteDeleteBtn"><i class="fas fa-trash-alt"></i></button>
                      </div>
                    </template>
                    <template v-else-if="zone.x > 1800">
                      <div :id="$store.state.index + 1 + '-' + zone.id" class='textBox' style="display:none; left:-750px;">
                        <i class="fa fa-times-circle exit" @click="closeNote"></i>
                        <textarea @keyup="addTextNote" v-model="zone.txt" :placeholder="literal['NOTA']"></textarea>
                        <button @click="deleteZoneActive(zone.id)" class="noteDeleteBtn"><i class="fas fa-trash-alt"></i></button>
                      </div>
                    </template>
                    <template v-else>
                      <div :id="$store.state.index + 1 + '-' + zone.id" class='textBox' style="display:none;">
                        <i class="fa fa-times-circle exit" @click="closeNote"></i>
                        <textarea @keyup="addTextNote" v-model="zone.txt" :placeholder="literal['NOTA']"></textarea>
                        <button @click="deleteZoneActive(zone.id)" class="noteDeleteBtn"><i class="fas fa-trash-alt"></i></button>
                      </div>
                    </template>
                    
                  </template>

                </div>
              </template>
            </aside>
            <!--PAGINA IZQUIERDA-->
            <EbookCropper :id="$store.state.index + 1" v-if="isCrop" :literal="literal" :img="rutaImg($store.state.index + 1)"></EbookCropper>
            <img v-else id="pageImgTwo" :src="rutaImg($store.state.index + 1)" style="width:auto; height:100%" />
            <!-- <Cropper id="pageImgOne" style="width:auto; height:100%;z-index:1000" :src="rutaImg($store.state.index + 1  )"></Cropper> -->
          </div>
        </article>
      </li>
    </ul>
    
    <!--COMPONENTE CRONOMETRO-->
    <ModalCronometro></ModalCronometro>
    <ModalAudio></ModalAudio>
  </main>
</template>

<script>

import { mapState, mapMutations } from 'vuex'
import $ from "jquery";
import ModalCronometro from "../components/modales/ModalCronometro";
import ModalAudio from "../components/modales/ModalAudio";
import EbookCropper from "../components/herramientas/EbookCropper";

export default {
  name: "Main",
  components:{
    ModalCronometro,
    posStart: null,
    posEnd: null,
    EbookCropper,
    ModalAudio
  },
  data: () => ({
    tPositionStart: null,
    tPositionEnd: null,
    areaPosition: false,
    zoneTrans: null,
    selectOne: false,
    selectTwo: false,
    areaPositionStart: {
      x1: 0,
      x2: 0,
      y1: 0,
      y2: 0
    }
  }),
  methods: {
    reCalc(){
      var x3 = Math.min(this.areaPositionStart.x1,this.areaPositionStart.x2);
      var x4 = Math.max(this.areaPositionStart.x1,this.areaPositionStart.x2);
      var y3 = Math.min(this.areaPositionStart.y1,this.areaPositionStart.y2);
      var y4 = Math.max(this.areaPositionStart.y1,this.areaPositionStart.y2);

      var page = "pag_"
      if(this.selectOne){
        var pageImg = document.getElementsByClassName("zonaTransparente");
        pageImg[0].style.transform = "scale(" + this.scale3d + ") translate(" + x3 + "px, " + y3 + "px)";
        pageImg[0].style.width = x4 - x3 + 'px';
        pageImg[0].style.height = y4 - y3 + 'px';
        page += this.$store.state.index;
      }

      if(this.selectTwo){
        var pageImg = document.getElementsByClassName("zonaTransparente");
        pageImg[1].style.transform = "scale(" + this.scale3d + ") translate(" + x3 + "px, " + y3 + "px)";
        pageImg[1].style.width = x4 - x3 + 'px';
        pageImg[1].style.height = y4 - y3 + 'px';
        page += this.$store.state.index + 1;
      }
      
      this.zoneTrans.x = x3;
      this.zoneTrans.y = y3;
      this.zoneTrans.width = x4 - x3;
      this.zoneTrans.height = y4 - y3;
      this.zoneTrans.page = page;
      this.zoneTrans.scale3d = this.scale3d
    },
    selectAreaDown(e){
      if(this.$store.state.ocultarBarra && this.transparente){
        this.areaPosition = true;
        this.$store.state.selectArea = true;
        this.zoneTrans = {}
        if(this.selectOne){
          var pageImgOne = document.getElementById("pageOne");
          this.areaPositionStart.x1 = (e.clientX - pageImgOne.getBoundingClientRect().left) / this.scale3d;
          this.areaPositionStart.y1 = (e.clientY - pageImgOne.getBoundingClientRect().top) / this.scale3d;
        }

        if(this.selectTwo){
          var pageImgTwo = document.getElementById("pageTwo");
          this.areaPositionStart.x1 = (e.clientX - pageImgTwo.getBoundingClientRect().left) / this.scale3d;
          this.areaPositionStart.y1 = (e.clientY - pageImgTwo.getBoundingClientRect().top) / this.scale3d;
        }
        
        this.reCalc();
      }
    },
    selectAreaMove(e){
      if(this.$store.state.ocultarBarra && this.areaPosition && this.transparente){
        var pageImg = document.getElementsByClassName("zonaTransparente");

        if(this.selectOne){
          var pageImgOne = document.getElementById("pageOne");
          pageImg[0].hidden = !this.$store.state.selectArea;
          this.areaPositionStart.x2 = (e.clientX - pageImgOne.getBoundingClientRect().left) / this.scale3d;
          this.areaPositionStart.y2 = (e.clientY - pageImgOne.getBoundingClientRect().top) / this.scale3d;
        }

        if(this.selectTwo){
          var pageImgTwo = document.getElementById("pageTwo");
          pageImg[1].hidden = !this.$store.state.selectArea;
          this.areaPositionStart.x2 = (e.clientX - pageImgTwo.getBoundingClientRect().left) / this.scale3d;
          this.areaPositionStart.y2 = (e.clientY - pageImgTwo.getBoundingClientRect().top) / this.scale3d;
        }
        
        this.reCalc();
      }
    },
    selectAreaUp(e){
      if(this.$store.state.ocultarBarra && this.transparente){
        this.areaPosition = false;
        this.setZoneActiveTrans(this.zoneTrans);
        this.setModalAddResource(true);
        this.$store.state.transparente = false;
      }
    },
    selectTouchAreaStart(e){
      
      if(this.$store.state.ocultarBarra && this.transparente && e.touches){
        this.areaPosition = true;
        this.selectOne = true;
        this.$store.state.selectArea = true;
        this.zoneTrans = {}
        var pageImgOne = document.getElementById("pageOne");
        this.areaPositionStart.x1 = (e.touches[0].clientX - pageImgOne.getBoundingClientRect().left) / this.scale3d;
        this.areaPositionStart.y1 = (e.touches[0].clientY - pageImgOne.getBoundingClientRect().top) / this.scale3d;
        
        this.reCalc();
      }
    },
    selectTouchAreaMove(e){
      if(this.$store.state.ocultarBarra && this.areaPosition && this.transparente && e.touches){
        var pageImg = document.getElementsByClassName("zonaTransparente");
        
        var pageImgOne = document.getElementById("pageOne");
        pageImg[0].hidden = !this.$store.state.selectArea;
        this.areaPositionStart.x2 = (e.touches[0].clientX - pageImgOne.getBoundingClientRect().left) / this.scale3d;
        this.areaPositionStart.y2 = (e.touches[0].clientY - pageImgOne.getBoundingClientRect().top) / this.scale3d;
      
        this.reCalc();
      }
    },
    selectTouchAreaEnd(e){
      if(this.$store.state.ocultarBarra && this.transparente && e.touches){
        this.areaPosition = false;
        this.setZoneActiveTrans(this.zoneTrans);
        this.setModalAddResource(true);
        this.$store.state.transparente = false;
        this.selectOne = false;
      }
    },
    touchSwiperStart(e){
      if(!this.$store.state.ocultarBarra && e.touches){
        this.tPositionStart = e.touches[0].clientX
      }
      
    },
    touchSwiperMove(e){
      if(!this.$store.state.ocultarBarra && e.touches){
        this.tPositionEnd = e.touches[0].clientX
      }
    },
    touchSwiperEnd(e){
      let result = this.tPositionEnd - this.tPositionStart;
      if(this.tPositionEnd && e.targetTouches.length != 2 && 80 < result){
        this.atras();
      }
      if(this.tPositionEnd && e.targetTouches.length != 2 &&  result < -80){
        this.siguiente();
      }
       this.tPositionEnd = null;
       this.tPositionStart = null;
    },
    zoneHover(id){
      if(this.$refs['zone-'+id] && this.$refs['zone-'+id][0]){
        this.$refs['zone-'+id][0].style.display = 'block'
      }
      return;
    },
    zoneOut(id){
      if(this.$refs['zone-'+id] && this.$refs['zone-'+id][0]){
        this.$refs['zone-'+id][0].style.display = 'none'
      }
      return;
    },
    editZone(zone){
      //Paso por copia
      this.setZoneDelete(JSON.parse(JSON.stringify(zone)));
      switch(zone.tipo){
        case "html":
        case "pdf":
        case "video":
        case "audio":
          this.setModalResource(true);
          break;
        case "linkPage":
          this.setModalAddResource(true);
          this.setWidthModal(1440);
          break;
        case "linkWeb":
          this.setModalAddResource(true);
          break;
      }
    },
    /**
    * La funcion se encarga añadir una zona activa
    */
    openActiveZone(e){
      this.$store.state.isModeActiveZone = false;
      let type = this.typeResource;
      switch(type){
        case 'note':
          this.addNote(e);
          break;
        case 'zoneT':
          e.scale3d = this.scale3d
          // this.setZoneActive(e);
          this.setModalAddResource(true);
          break;
        case 'zone':
          e.scale3d = this.scale3d
          this.setZoneActive(e);
          this.setModalAddResource(true);
          break;
      }
      $('aside').css('cursor', 'default');

      //Para que no se vuelva a agregar una zona activa
      this.setTypeResource("")
    },

    openNote(e){
      e.target.parentNode.children[1].style.display = 'block';
    },

    closeNote(e){
      e.target.parentNode.style.display = 'none';
    },

    addNote(e){
      let page = 'pag_' + e.target.getAttribute('data-page');
      let posX = (((e.pageX - e.target.getBoundingClientRect().x) / this.$store.state.escala) * (1 / this.scale3d)).toFixed(3) - 50;
      let posY = (((e.pageY - e.target.getBoundingClientRect().y) / this.$store.state.escala) * (1 / this.scale3d)).toFixed(3) - 50;
      let id = this.$store.state.zoneID++;

      //Creacion de Objeto nota
      let note = {"id":id,"x": posX, "y":posY,"txt": null, "tipo":"note"}
      let  payload = {page: page, data: note}
      this.addZoneActive(payload)
    },

    addTextNote(e){
      
      let txt = e.target.value;
      let contenedoPadre = e.target.parentNode;
      let page = 'pag_' + contenedoPadre.getAttribute('id').split('-')[0];
      let note = contenedoPadre.getAttribute('id').split('-')[1]

      let i = 0;
      
      for(i = 0; i < this.zonasActivas[this.$store.state.indexLM][page].length; i++){
        if(this.zonasActivas[this.$store.state.indexLM][page][i].id == note){
          break;
        }
      }

      this.$set(this.zonasActivas[this.$store.state.indexLM][page][i], 'txt', txt)
      this.$store.state.service.setZoneActive(this.$store.state.zonasActivas);
    },
    openLinkWeb(url){
      window.open(url);
    },

    openDocumento(tipo ,url){
      window.open('recursos/DOCUMENTOS/' + url + '.' + tipo);
      
    },

    /**
    * @param {String} - nombre numerico de la imagen
    * @return {Function(rutaImg{String})} - retorna la imagen si es que existe
    */
    rutaImg(img){
      if(img != null){
        try{
          let carpetaLM = this.$store.state.ebook[this.$store.state.indexLM].carpeta; //Carpeta donde se aloja las paginas del LM
          
          let existeImg = require("@/assets/img/paginas/" + carpetaLM +"/" + (img + 1) + ".jpg"); //Se encarga de llamar a la imagen de la carpeta del LM
          return existeImg;
        } catch {
          console.log("error, no se encuentra la imagen")
          return ''
        }
      } 
      return '';
    },

    /**
    * @param {String} - posicion del LM al que se desea ir
    * La funcion se encarga de dirigir al LM que se selecciona en la pestaña
    */
    irLM(i){
      
      let viewer = document.getElementById('viewer')
      viewer.classList.add('single');
      this.$store.state.index = 0;//Pone como posicion inicial 0 cuando se dirige al LM selecionado
      this.$store.commit('correcionLM', i);//Deshabilita la pestaña seleccionada
      this.$store.commit('resetearCanvas');//Resetea el canvas
      this.$store.commit('resizeWindow');
      
    },

    ...mapMutations(["setModalResourceFull", 
                      "setModalResource",
                      "setMobile", 
                      "setTypeResource", 
                      "setModalAddResource", 
                      "setZoneActive", 
                      "setZoneActiveTrans",
                      "addZoneActive", 
                      "buscarLMUnidad",
                      "correcionLM",
                      "setZoneDelete",
                      "setWidthModal",
                      "deleteZoneActive",
                      "openModalAudioVideo",
                      "limites",
                      "siguiente",
                      "atras", "resizeWindow"]) 
  },
  created: function(){
    var goPage = this.service.getIndexEbook();
    if(goPage){
      this.$store.state.indexLM = goPage.lm
      if(goPage.page != 0){
        if(goPage.page % 2 == 0){
          if(window.innerWidth < 980){
            this.$store.state.index = goPage.page
          } else{
            this.$store.state.index = goPage.page - 1
          }
        } else {
          this.$store.state.index = goPage.page
        }
      }
    }
  },
  computed: {

    sizeScreen(){
      if(this.isMobile){
        return 100;
      }

      return this.$store.state.ebook[this.$store.state.indexLM].tamanioPantalla;
    },

    /**
    * Logica de las Zonas Activas, enlaces y cuadro de texto
    */
    insertarZona1() {
      this.cargarZonaActiva(1)
    },
    insertarZona2() {
      this.cargarZonaActiva(2)
    },
    ...mapState(["scale3d",'loading','zonasActivas', 'literal', 'isMobile', 'typeResource', 'openHZone', 'isCrop', 'service', 'transparente', 'config'])
  },
  /**
    * Se redimensiona la pagina cuando el html este cargado
    */
  mounted: function() {
    $('.btnPaginationLeft').addClass('isInactiveCanvas');
    $('.btnPaginationRight').addClass('isInactiveCanvas');
    $(".inputPagination").prop('disabled', true);
    $("#btnPages").addClass('isInactiveCanvas');
    $(".contBtnUnits").addClass('isInactiveCanvas');
    $(".pestana").addClass('pestanaDesactivadaCanvas');
    $(".icon-zoom").addClass('isInactiveCanvas');
    // $(".icon-media ").addClass('isInactiveCanvas');
    var goPage = this.service.getIndexEbook();
    // this.$store.commit('redimensionar');
    this.correcionLM(goPage.lm)
    this.limites(true)

    this.setMobile();

    // setTimeout(() => {
    //   this.loading = true;
    // }, 3000);

    //Se almacena la escala que tendra todos las zonas activas

    new Promise((resolve, reject) => {
      let img = document.createElement('img');
        
      let carpetaLM = this.$store.state.ebook[this.$store.state.indexLM].carpeta;
      let existeImg = require("@/assets/img/paginas/" + carpetaLM +"/" + (this.$store.state.index + 1) + ".jpg");
      
      img.src= existeImg;
      img.onload = resolve();
      img.onerror = reject();

    })
    .then(() => {

      let img = new Image();
        
      let carpetaLM = this.$store.state.ebook[this.$store.state.indexLM].carpeta;
      let existeImg = require("@/assets/img/paginas/" + carpetaLM +"/" + (this.$store.state.index + 1) + ".jpg");
      img.src= existeImg;
      
      img.onload = () => {
        
        if(img.height < 1500){
          this.$store.state.scale3d = ($('#pageImgOne').height() / 1750).toFixed(3);
        } else{
          this.$store.state.scale3d = ($('#pageImgOne').height() / img.height).toFixed(3);
        }
        
        // this.scale3d = ($('#pageImgOne').height() / (2200)).toFixed(3);
        var canvas = document.getElementById('canvasMain');
        var li = document.getElementById('pageLM');
        canvas.width = li.clientWidth;
        canvas.height = li.clientHeight;
        this.$store.state.loading = true;
        $('.btnPaginationLeft').removeClass('isInactiveCanvas');
        $('.btnPaginationRight').removeClass('isInactiveCanvas');
        $(".inputPagination").prop('disabled', false);
        $("#btnPages").removeClass('isInactiveCanvas');
        $(".contBtnUnits").removeClass('isInactiveCanvas');
        $(".pestana").removeClass('pestanaDesactivadaCanvas');
        $(".icon-zoom").removeClass('isInactiveCanvas');
      //  $(".icon-media ").removeClass('isInactiveCanvas');
      }

      window.addEventListener("resize", ()=>{
        this.resizeWindow();
      });

      
    })
    .catch(()=>{
      console.log("ERROR MOUNTED")
    });
    
      
    // this.scale3d = ($('#pageImgOne').height() / (2200)).toFixed(3);
    
      
      var viewer = document.getElementById("viewer");
      viewer.addEventListener("touchstart", this.touchSwiperStart);
      viewer.addEventListener("touchend", this.touchSwiperEnd);
      viewer.addEventListener("touchmove", this.touchSwiperMove);

      var pageImgOne = document.getElementById("pageOne");

      pageImgOne.addEventListener("mousedown", this.selectAreaDown);
      pageImgOne.addEventListener("mouseup", this.selectAreaUp);
      pageImgOne.addEventListener("mousemove", this.selectAreaMove);

      var pageImgTwo = document.getElementById("pageTwo");

      pageImgTwo.addEventListener("mousedown", this.selectAreaDown);
      pageImgTwo.addEventListener("mouseup", this.selectAreaUp);
      pageImgTwo.addEventListener("mousemove", this.selectAreaMove);

      pageImgOne.addEventListener("touchstart", this.selectTouchAreaStart);
      pageImgOne.addEventListener("touchend", this.selectTouchAreaEnd);
      pageImgOne.addEventListener("touchmove", this.selectTouchAreaMove);
      
  }
};
</script>

<style>

.containerLoader{
  position: fixed;
  
  width: 100%;
  height: 70%;
  z-index: 1000;
}
.centrarLoader {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
</style>